import Vue from 'vue'
import Vuex from 'vuex'
import axios from './axios-auth'
import router from '../router/router'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		// STATE FOR LOGIN
		ApiToken:null,
		UserRoleId: null,
		Error401:false,
		Message:null,
		ForgotPass:null,
		BrowserDetect: null,

		//STATE MODAL / NOTIF
		showDialog: false,
		showDialogTwo: false,
		showDialogThree: false,
		loadingTrue: false,

		//UPCOMING SESSIONS
		stateUpcomingSession: null,
		sessionDetail: null,
		sessionDetailCoach: null,
		stateRescheduleDate: null,
		rescheduleCoachAvailable: null,
		stateStartEndTime: null,
		rescheduleTimeAvailable: null,
		rescheduleResponse: null,
		stateRecUrl: null,

		// STUDY DASHBOARD
		stateCall1Call2: null,
		stateStudyDashboard: null,
		stateStuDashCoaching: null,
		stateWeeklyProgress: null,
		stateB2CSummary: null,

		// TOKEN STATE
		UserToken: null,
		reqToken: null,
		DashTokenHistory: null,
		stateTokenFilterDate: null,

		//STATE FOR PROFILE PAGE
		DataAdditional : null,
		TokenProfile:null,
		ChangePass : null,
		SessionHistory:null,
		OtherProfiles : null,
		CoachSeeStudentNote : null,

		CckLoadAvatar:null,
		CckLoadDataPrsinfo:null,
		CckLoadDtTmZone:null,

		//STATE FOR BOOK COACH PAGE
		AvailableCoach : null,
		AvailableCoachSelect:null,
		AvailableTimeCoachSelect:null,
		AvailableBookSummary: null,
		ConfirmBookSummary: null,
		FilterLoading:null,
		AvailableSelect: null,
		AvailableFilter:null,
		FilterGetData:null,
		FilterBookType:null,
		CoachDaysOff:null,
		LodingCkSchedule: null,
		loadFilter: null,
		loadSummary: null,

		//STATE FOR DASHBOARD
		DashUpcomingSessions : null,
		stateStartSessionStd: null,
		stateStartSessionCch: null,
		StartLiveSession: null,
		UpcomingSelect:null,

		// LIVE SESSION STUFF
		opentokApiKey: "46157142",
		StudentSummary: null,
		CoachSummary: null,
		CoachNote: null,
		AgoraInfo : null,
		AlertFive:null,

		// OPENTOK STUFF
		stateOpentokSession: null,
		stateCallQuality: false,

		//LIVE SESSION TAB
		DataScriptB2i : null,
		MarkDataScriptB2i:null,
		GetMarkDataScriptB2i: null,
		CckGET_DATA_B2I_SCRIPTS:null,
		CckGET_MARK_DATA_B2ISCRIPTS:null,


		// SESSION SIMULATOR
		stateSessionSimulator: null,

		// SNACKBAR NOTIFICATION
		stateSnackbarMessage: null,
		stateSnackbarVal: null,

		//LOADER THING
		stateLoader: false,

		// RESPONSIVE THING
		stateResizeScreen: null,

		//HELP PAGE
		stateHelp: null,
		stateClickedHelpList: null,
		muttSelectedHelpData: null,

		// SERVER TIME THING
		stateServerTime: null,

		//HEADER NOTIFICATIONS
		HeaderNotifALL : null,
		HeaderNotifLatest: null,
		ShowBadges : false,


		//CHECKlOAD
		AllertCont:null,
		CheckUpcomingSession :null,
		CheckCoinHistory : null,
		CheckCoin: null,
		CheckHeaderLastNotif:null,
		CheckServerTime:null,
		CheckHeaderAllNotif:null,
		CheckDeleteAllNotif:null,
		CheckShistory: null,
		CckLoadDataProf:null,
		CheckStudyDashb:null,
		CckLoadDataOtherProf: null,
		CheckCoachSchedules : null,
		CheckFilterCoachLangCountry:null,
		LoadAvCoach: null,
		CckConfirmBookSummary:null,
		LiveSessionSummary:null,
		CckRecUrl:null,
		CckLengthChat:null,
		CckTrigerscroll:null,

		//LIVE SESSION MESSAGE NOTIF
		stateNotifChat: null
	},
	mutations: {
		authUser (state, authUser){
			state.ApiToken = authUser.ApiToken
		},
		roleId (state, roleId){
      state.UserRoleId = roleId.UserRoleId
    	},
		authError(state, authError){
			state.Error401 = authError.Error401
		},
		loginStatus(state, loginStatus){
			state.Message = loginStatus.Message
		},
		muttForgotPass(state, ForgotPass){
			state.ForgotPass = ForgotPass
		},
		toggleDialog (state) {
			state.showDialog = !state.showDialog
		},
		toggleDialogTwo (state) {
			state.showDialogTwo = !state.showDialogTwo
		},
		toggleDialogThree (state, showDialogThree) {
			state.showDialogThree = showDialogThree
		},
		toggleDialogFalse (state) {
			state.showDialog = false
		},
		buttonLoading (state) {
			state.loadingTrue = true
		},
		muttBrowserDetect(state, BrowserDetect){
			state.BrowserDetect = BrowserDetect
		},
		//TOKEN MUTATIONS
		dataToken(state, UserToken){
			state.UserToken = UserToken
		},
		storeCoinRes(state, reqToken) {
			state.reqToken = reqToken
		},
		storeDataDashTokenHistory(state, DashTokenHistory){
       	state.DashTokenHistory = DashTokenHistory
		},
		commitTokenFilterDate(state, stateTokenFilterDate) {
			state.stateTokenFilterDate = stateTokenFilterDate
		},

		//UPCOMING SESSION MUTATIONS
		commitUpcomingSession(state, stateUpcomingSession) {
			state.stateUpcomingSession = stateUpcomingSession
		},
		storeSessionDetail(state, sessionDetail) {
			state.sessionDetail = sessionDetail
		},
		storeSessionDetailCoach(state, sessionDetailCoach) {
			state.sessionDetailCoach = sessionDetailCoach
		},
		commitRescheduleDate (state, stateRescheduleDate) {
			state.stateRescheduleDate = stateRescheduleDate
		},
		commitRescheduleCoachAvailable(state, rescheduleCoachAvailable) {
			state.rescheduleCoachAvailable = rescheduleCoachAvailable
		},
		commitStartEndTime(state, stateStartEndTime) {
			state.stateStartEndTime = stateStartEndTime
		},
		storeTimeRescheduleAvailable(state, rescheduleTimeAvailable){
			state.rescheduleTimeAvailable = rescheduleTimeAvailable
		},
		muttStartLiveSession(state, StartLiveSession){
			state.StartLiveSession =  StartLiveSession
		},
		stateRescheduleResponse(state, rescheduleResponse) {
			state.rescheduleResponse = rescheduleResponse
		},
		coachAvailableNull (state) {
			state.rescheduleTimeAvailable = null
		},
		commitRecUrl (state, stateRecUrl) {
			state.stateRecUrl = stateRecUrl
		},
		muttCckRecUrl(state, CckRecUrl){
			state.CckRecUrl = CckRecUrl
		},

		// STUDY DASHBOARD MUTATIONS
		commitCall1Call2 (state, stateCall1Call2) {
			state.stateCall1Call2 = stateCall1Call2
		},
		commitStudyDashboard (state, stateStudyDashboard) {
			state.stateStudyDashboard = stateStudyDashboard
		},
		commitStuDashCoaching (state, stateStuDashCoaching) {
			state.stateStuDashCoaching = stateStuDashCoaching
		},
		commitWeeklyProgress (state, stateWeeklyProgress) {
			state.stateWeeklyProgress = stateWeeklyProgress
		},
		commitB2CSumary (state, stateB2CSummary) {
			state.stateB2CSummary = stateB2CSummary
		},

		//MUTTAIONS FOR PAGE PROFILE
		storeDataAdditional(state, DataAdditional){
			state.DataAdditional = DataAdditional
		},
		storeGetToken(state,TokenProfile){
			state.TokenProfile =TokenProfile
		},
		storeChangePass(state, ChangePass){
			state.ChangePass = ChangePass
		},
		muttSessionHistory(state, SessionHistory){
			state.SessionHistory = SessionHistory
		},
		muttOtherProfiles(state, OtherProfiles){
			state.OtherProfiles = OtherProfiles
		},
		muttCoachSeeStudentNote(state, CoachSeeStudentNote){
			state.CoachSeeStudentNote = CoachSeeStudentNote
		},
		muttCckLoadDataProf(state, CckLoadDataProf){
			state.CckLoadDataProf = CckLoadDataProf
		},
		muttCckLoadAvatar(state, CckLoadAvatar){
			state.CckLoadAvatar = CckLoadAvatar
		},
		muttCckLoadDataPrsinfo(state, CckLoadDataPrsinfo){
			state.CckLoadDataPrsinfo = CckLoadDataPrsinfo
		},
		muttCckLoadDtTmZone(state, CckLoadDtTmZone){
			state.CckLoadDtTmZone = CckLoadDtTmZone
		},

		// LOGOUT
		clearAuthData (state) {
			//LOGIN
     	state.ApiToken = null
			state.UserRoleId = null
			state.Message =null
			state.BrowserDetect= null
			state.ForgotPass= null

			//HEADER
			state.profile = null
			state.UserToken = null

			//PAGE PROFILE



			state.CoachSeeStudentNote = null
			state.OtherProfile = null

			state.CckLoadAvatar = null
			state.CckLoadDataPrsinfo = null
			state.CckLoadDtTmZone = null

			//PAGE UPCOMING SESSION
			state.sessionDetail = null
			state.stateUpcomingSession = null
			state.sessionDetailCoach = null
			state.stateRescheduleDate = null
			state.rescheduleTimeAvailable = null
			state.rescheduleCoachAvailable = null
			state.stateStartEndTime = null
			state.rescheduleResponse = null
			state.UpcomingSelect = null
			state.stateRecUrl = null

			//PAGE BOOK COACH
			state.AvailableBookSummary = null
			state.AvailableCoach = null
			state.AvailableTimeCoachSelect = null
			state.AvailableCoachSelect = null
			state.ConfirmBookSummary = null

			state.AvailableFilter = null
			state.FilterGetData = null
			state.FilterBookType= null
			state.CoachDaysOff = null
			state.stateGetDayoff = null
			state.LodingCkSchedule = null

			state.loadFilter = null
			state.loadSummary= null

			//PAGE DASHBOARD

			state.reqToken = null
			state.stateStartSessionStd = null
			state.stateStartSessionCch = null
			state.StartLiveSession = null

			// PAGE LIVE SESSION
			state.StudentSummary = null
			state.CoachSummary = null
			state.CoachNote = null
			state.stateOpentokSession = null
			state.stateCallQuality = null
			state.stateSessionSimulator = null

			// PAGE STUDY PROGRESS
			state.stateStudyDashboard = null
			state.stateStuDashCoaching = null
			state.stateWeeklyProgress = null
			state.stateB2CSummary = null

			//LIVE SESSION TAB
			state.DataScriptB2i = null
			state.MarkDataScriptB2i= null
			state.GetMarkDataScriptB2i = null

			// SNACKBAR MESSAGE
			state.stateSnackbarMessage = null
			state.stateSnackbarVal = null

			//LOADER THING
			state.stateLoader = false

			// RESPONSIVE THING
			state.stateResizeScreen = null

			// HELP PAGE
			state.stateHelp = null
			state.stateClickedHelpList = null
			state.muttSelectedHelpData = null

			state.Error401 = false
			state.stateNotifChat = null

	 },
		MuttClearState(state){
			//STATE COMPONENT CONTENT
			state.AllertCont = null
			state.ForgotPass= null

			//STATE COMPONENT IN DASHBOARD
			state.DashUpcomingSessions = null
			state.DashTokenHistory = null
			state.stateTokenFilterDate = null
			state.CheckUpcomingSession = null
			state.CheckCoin = null
			state.CheckCoinHistory = null
			state.TokenProfile = null

			//STATE COMPONENT IN STUDENT PROFILE VIEW
			state.DataAdditional = null
			state.SessionHistory = null
			state.CckLoadDataProf = null

			state.CckLoadDataOtherProf = null
			state.CheckCoachSchedules = null

			//STATE COMPONENT IN STUDY DASHBOARD
			state.stateCall1Call2 = null
			state.CheckStudyDashb = null

			//STATE COMPONENT IN HEADER
			state.stateServerTime = null
			state.HeaderNotifLatest = null
			state.HeaderNotifALL = null
			state.CheckHeaderLastNotif = null
			state.CheckServerTime = null
			state.CheckHeaderAllNotif = null
			state.CheckDeleteAllNotif = null


			// PAGE BOOK COACH
			state.AvailableSelect = null
			state.CheckFilterCoachLangCountry = null
			state.LoadAvCoach = null

			state.AgoraInfo = null
			state.AlertFive = null

			state.Error401 = false
			state.FiveParamLogin = null
			state.CheckShistory = null

			state.ShowBadges = false
			state.LiveSessionSummary = null
			state.CckRecUrl = null
			state.CckLengthChat = null
			state.CckTrigerscroll = null


		},
		MuttClearStateAfterLiveSessionAgora(state){
			state.AgoraInfo = null
			state.AlertFive = null
			state.CckConfirmBookSummary = null
			state.StartLiveSession = null
			state.LiveSessionSummary = null
			state.CckLengthChat = null
			state.CckTrigerscroll = null
		},

		// HEADER DATA
		storeDataHeader (state, storeDataHeader) {
			state.profile = storeDataHeader.profile
		},

		//MUTTATIONS FOR PAGE BOOK COACH
		availableCoachDataSelect(state,AvailableCoachSelect){
			state.AvailableCoachSelect = AvailableCoachSelect
		},
		storeDataAvailableCoach(state, AvailableCoach){
			state.AvailableCoach = AvailableCoach
		},
		storeCoachTimeAvailable(state, AvailableTimeCoachSelect){
			state.AvailableTimeCoachSelect =AvailableTimeCoachSelect
		},
		storeCoachBookSummary(state, AvailableBookSummary){
			state.AvailableBookSummary = AvailableBookSummary
		},
		storeConfirmSummary(state, ConfirmBookSummary){
			state.ConfirmBookSummary = ConfirmBookSummary
		},
		storeFilterLoading(state, FilterLoading){
			state.FilterLoading = FilterLoading
		},
		storeAvailableSelect(state,AvailableSelect){
			state.AvailableSelect = AvailableSelect
		},
		storeAvailableFilter(state, AvailableFilter){
			state.AvailableFilter = AvailableFilter
		},
		storeFilterGetData(state,FilterGetData){
			state.FilterGetData = FilterGetData
		},
		StoreFilterBookType(state, FilterBookType){
			state.FilterBookType = FilterBookType
		},
		muttCoachDaysOff(state, CoachDaysOff){
			state.CoachDaysOff = CoachDaysOff
		},
		muttLodingCkSchedule(state,LodingCkSchedule){
			state.LodingCkSchedule = LodingCkSchedule
		},
		muttloadFilter(state, loadFilter){
			state.loadFilter = loadFilter
		},
		muttloadSummary(state, loadSummary){
			state.loadSummary = loadSummary
		},

		//MUTTATIONS FOR PAGE DASHBOARD
		storeDataUpcomingSession(state, DashUpcomingSessions){
			state.DashUpcomingSessions = DashUpcomingSessions
		},
		commitStartSessionStd(state, stateStartSessionStd) {
			state.stateStartSessionStd = stateStartSessionStd
		},
		commitStartSessionCch(state, stateStartSessionCch) {
			state.stateStartSessionCch = stateStartSessionCch
		},
		muttUpcomingSelect(state, UpcomingSelect){
			state.UpcomingSelect = UpcomingSelect
		},

		//MUTTATIONS FOR PAGE STUDENT LIVE SUMMARY
		MuttStudentSummary(state, StudentSummary){
			state.StudentSummary = StudentSummary
		},
		MuttCoachSummary(state, CoachSummary){
			state.CoachSummary = CoachSummary
		},
		MuttCoachNote(state, CoachNote){
			state.CoachNote = CoachNote
		},
		MuttAgoraInfo(state, AgoraInfo){
			state.AgoraInfo = AgoraInfo
		},
		muttalertFive(state, AlertFive){
			state.AlertFive = AlertFive
		},

		// SESSION SIMULATOR
		commitSessionSimulator(state, stateSessionSimulator) {
			state.stateSessionSimulator = stateSessionSimulator
		},

		// OPENTOK MUTATIONS
		commitOpentokSession(state, opentokSession) {
			state.stateOpentokSession = opentokSession
		},
		commitCallQuality(state, stateCallQuality) {
			state.stateCallQuality = stateCallQuality
		},

		//LIVE SESSION TAB
		muttDataScriptB2i(state, DataScriptB2i){
			state.DataScriptB2i = DataScriptB2i
		},
		muttMarkDataScriptB2i(state, MarkDataScriptB2i){
			state.MarkDataScriptB2i = MarkDataScriptB2i
		},
		muttGetMarkDataScriptB2i(state, GetMarkDataScriptB2i){
			state.GetMarkDataScriptB2i = GetMarkDataScriptB2i
		},
		// SNACKBAR NOTIFICATION
		commitSnackbarMessage(state, stateSnackbarMessage) {
			state.stateSnackbarMessage = stateSnackbarMessage
		},
		commitSnackbarVal(state, stateSnackbarVal) {
			state.stateSnackbarVal = stateSnackbarVal
		},
		// LOADER THING
		commitLoader(state, stateLoader) {
			this.stateLoader = stateLoader
		},
		// RESPONSIVE THING
		commitResizeScreen (state, resizeScreen) {
			state.stateResizeScreen = resizeScreen
		},
		//HELP PAGE
		commitHelp (state, stateHelp) {
			state.stateHelp = stateHelp
		},
		commitHelpList (state, title) {
			state.stateClickedHelpList = title
		},
		muttSelectedHelpData (state, stateSelectedHelpData) {
			state.stateSelectedHelpData = stateSelectedHelpData
		},
		// SERVER TIME MUTTAION
		commitServerTime (state, stateServerTime) {
			state.stateServerTime = stateServerTime
		},

		//HEADER NOTIFICATIONS
		muttHeaderNotifALL(state, HeaderNotifALL){
			state.HeaderNotifALL = HeaderNotifALL
		},
		muttHeaderNotifLatest(state, HeaderNotifLatest){
			state.HeaderNotifLatest = HeaderNotifLatest
		},
		muttShowBadges(state, ShowBadges){
			state.ShowBadges = ShowBadges
		},
		muttContainerNotif(state, ContainerNotif){
			state.ContainerNotif =ContainerNotif
		},

		//CHECK LOAD DATA
		MuttAllertCont(state, AllertCont){
			state.AllertCont = AllertCont
		},
		muttCheckUpcomingSession(state, CheckUpcomingSession){
			state.CheckUpcomingSession = CheckUpcomingSession
		},
		muttCheckCoin(state, CheckCoin){
			state.CheckCoin = CheckCoin
		},
		muttCheckCoinHistory(state, CheckCoinHistory) {
			state.CheckCoinHistory = CheckCoinHistory
		},
		muttCheckHeaderLastNotif(state, CheckHeaderLastNotif){
			state.CheckHeaderLastNotif = CheckHeaderLastNotif
		},
		muttCheckServerTime(state, CheckServerTime){
			state.CheckServerTime = CheckServerTime
		},
		muttCheckHeaderAllNotif(state, CheckHeaderAllNotif){
			state.CheckHeaderAllNotif = CheckHeaderAllNotif
		},
		muttCheckDeleteAllNotif(state, CheckDeleteAllNotif){
			state.CheckDeleteAllNotif = CheckDeleteAllNotif
		},
		muttCheckShistory(state, CheckShistory){
			state.CheckShistory = CheckShistory
		},
		muttCheckStudyDashb(state, CheckStudyDashb){
			state.CheckStudyDashb = CheckStudyDashb
		},
		muttCckLoadDataOtherProf(state, CckLoadDataOtherProf){
			state.CckLoadDataOtherProf = CckLoadDataOtherProf
		},
		muttCheckCoachSchedules(state, CheckCoachSchedules){
			state.CheckCoachSchedules = CheckCoachSchedules
		},
		muttCheckFilterCoachLangCountry(state, CheckFilterCoachLangCountry){
			state.CheckFilterCoachLangCountry = CheckFilterCoachLangCountry
		},
		muttLoadAvCoach(state, LoadAvCoach){
			state.LoadAvCoach = LoadAvCoach
		},
		muttCckConfirmBookSummary(state, CckConfirmBookSummary){
			state.CckConfirmBookSummary = CckConfirmBookSummary
		},
		muttLiveSessionSummary(state, LiveSessionSummary){
			state.LiveSessionSummary = LiveSessionSummary
		},
		muttCckLengthChat(state, CckLengthChat){
			state.CckLengthChat = CckLengthChat
		},
		muttCckTrigerscroll(state, CckTrigerscroll ){
			state.CckTrigerscroll = CckTrigerscroll
		},

		//LIVE SESSION MESSAGE NOTIF
		muttNotifChat (state, stateNotifChat) {
			state.stateNotifChat = stateNotifChat
		},
	},
	actions: {
		// Action For LOGIN PAGE Global
		// POST_LOGIN({commit, dispatch}, ConvertFormLogin){
		// 	axios.post('https://b2ctest.id.dyned.com/api/v1/jwt/token-request', ConvertFormLogin)
		// 	.then(res => {
		// 		console.log(res)
		// 		commit('authUser',{
		// 			ApiToken: res.data.token
		// 		}),
		// 		commit('loginStatus',{
		// 			Message: 'login Success'
		// 		})
		// 		dispatch('LOGIN_SUCCSESSFUL')
		// 	})
		// 	.catch(error => {
		// 		console.log(error)
		// 		commit('authError',{
		// 			Error401: true
		// 		}),
		// 		commit('loginStatus',{
		// 			Message: 'login Fail'
		// 		})
		// 		dispatch('LOGIN_FAILED')
		// 	})
		// },
		// Action For LOGIN PAGE China
		POST_LOGIN({commit, dispatch}, ConvertFormLogin){
			axios({
				method: 'POST',
        url: 'https://cors-anywhere.herokuapp.com/https://myneodev.dyned.com.cn/api/v1/jwt/token-request',
        data : ConvertFormLogin,
				headers: {
		      'Access-Control-Allow-Origin' : '*',
		      'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
		    },
			})
			.then(res => {
				console.log(res);
				commit('authUser',{
					ApiToken: res.data.token
				}),
				commit('loginStatus',{
					Message: 'login Success'
				})
				dispatch('LOGIN_SUCCSESSFUL')
			})
			.catch(err => {
				console.log(err)
				commit('authError',{
					Error401: true
				}),
				commit('loginStatus',{
					Message: 'login Fail'
				})
				dispatch('LOGIN_FAILED')
			})
		},

		LOGIN_SUCCSESSFUL({commit, state, dispatch}){
			localStorage.token = state.ApiToken
			delete localStorage.Error401

			// TO GET USER PROFILE FOR HEADER
      axios.get('/profile',{
        headers: {
          Authorization: localStorage.getItem('token')
        }
      })
      .then(res =>{
        // console.log(res)
        commit('storeDataAdditional', res.data)

				// TO GET USER ROLE
				axios.get('/acl', {
	        headers: {
	          Authorization: localStorage.getItem('token')
	        }
	      })
	      .then(res => {
	        	commit('roleId', {
	          UserRoleId: res.data.live.roles[0]
	        	})
					if (state.DataAdditional.timezone == null) {
				   	router.push('/timezone')
				  	} else {
						if (state.UserRoleId == "coach") {
							commit('clearAuthData')
							commit('authError',{
								Error401: true
							})
		          		router.push('/login')
						} else if (state.UserRoleId == "student") {
							router.push('/student')
							dispatch('GET_SERVER_TIME');
		        		}
				  	}

	      })
				.catch(err => {
	        	console.log(err)
	      })
      })
			.catch(err => {
				console.log(err)
				if(err.response.message ="Your Account has expired"){
					commit('loginStatus',{
						Message: 'Account expired'
					})
					commit('authError',{
						Error401: true
					})
					commit('authUser',{
						ApiToken: null
					})
				}
			})
		},

		LOGIN_FAILED({state}){
			localStorage.Error401 = state.Error401
			delete localStorage.token
			delete localStorage.vuex
		},
		LOGOUT ({commit}) {
			commit('clearAuthData')
			delete localStorage.vuex
			localStorage.removeItem('vuex')
			localStorage.removeItem('token')
			localStorage.removeItem('expirationDate')
			router.replace('/login')
		},
		CLEAR_STATE({commit}){
			commit('MuttClearState')
		},

		// ACTION FOR PROFILE PAGE
		GET_PROFILEADDITIONAL({commit}){
			axios.get('/profile',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				commit('storeDataAdditional', res.data)
				commit('muttCckLoadDataProf', res)
			})
			.catch(err => {
				commit('storeDataAdditional', err.response)
				commit('muttCckLoadDataProf', err.response)
			})
		},
		// ACTION FOR PROFILE PAGE TIMEZONE
		POST_PROFILEADDITIONAL({commit, dispatch, state}, formProfile){
			axios({
				method: 'POST',
				url: '/timezones',
				data: formProfile,
				headers: {Authorization: localStorage.token}
			})
			.then(res =>{
				console.log(res)
				commit('storeDataAdditional', res.data)
				// console.log("ini commit data additional " + state.profile);

				if (state.DataAdditional.message == "success") {
					if (state.UserRoleId == "coach") {
						commit('clearAuthData')
						commit('authError',{
								Error401: true
						})
		          	router.push('/login')
					} else if (state.UserRoleId == "student") {
						router.push('/student')
					}
				}
			})
			.catch(error => {
				console.log(error)
			})
		},

		//GET SESSION HISTORY STUDENT
		GET_PROFILE_SESSION_HISTORY({commit}){
			axios.get('/session/history',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				commit('muttCheckShistory', res)
				commit('muttSessionHistory', res.data)
			})
			.catch(err => {
				commit('muttCheckShistory', err.response)
				commit('muttSessionHistory', err.response)
			})
		},
		POST_HISTORY_SESSION_DATE ({commit, dispatch}, rangeDate) {
			axios({
        method: 'POST',
        url: '/session/search_history/',
        data: rangeDate,
        headers: {Authorization: localStorage.getItem('token')}
       })
       .then(res => {
         console.log(res);
         commit('muttSessionHistory', res.data)
       })
       .catch(function (error) {
         console.log(error);
       });
		},

		GET_PROFILE_OTHERS({commit}, Username){
			axios.get(`/profile/${Username}`,{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				console.log(res)
				commit('muttOtherProfiles', res.data)
				commit('muttCckLoadDataOtherProf', res)
			})
			.catch(err => {
				commit('muttOtherProfiles', err.response)
				commit('muttCckLoadDataOtherProf', err.response)
			})
		},

		//LIVE SESSION TAB
		GET_DATA_B2I_SCRIPTS({commit}, Username){
			axios.get(`/scripts/B2I/${Username}`,{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				console.log(res)
				commit('muttDataScriptB2i', res.data)
			})
			.catch(error => {
				console.log(error)
			})
		},

		POST_MARK_DATA_B2ISCRIPTS({commit, state, dispatch}, MarkData){
			axios({
				method: 'POST',
				url: '/scripts/mark',
				data: MarkData,
				headers: {Authorization: localStorage.token}
			})
			.then(res =>{
				// console.log(res)
				commit('muttMarkDataScriptB2i', res.data)
				if(res.status === 200 ){
					const Username = MarkData.username
					dispatch('GET_MARK_DATA_B2ISCRIPTS', Username)
				}
			})
			.catch(error => {
				console.log(error)
			})
		},

		DELETE_UNMARK_DATA_B2ISCRIPTS({commit, state, dispatch}, ids){
			axios({
				method: 'DELETE',
				url: `/scripts/${ids.id}`,
				headers: {
					'Authorization': localStorage.token,
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			})
			.then(res =>{
				//console.log(res)

				if(res.status === 200 ){
					const Username = ids.username
					dispatch('GET_MARK_DATA_B2ISCRIPTS', Username)
				}
			})
			.catch(error => {
				console.log(error)
			})
		},


		GET_MARK_DATA_B2ISCRIPTS({commit}, Username){
			axios.get(`/scripts/${Username}`,{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				// console.log(res)
				commit('muttGetMarkDataScriptB2i', res.data)
			})
			.catch(error => {
				console.log(error)
			})
		},

		GET_COACH_SEE_STUDENT_NOTE({commit}, Username){
			axios.get(`/session/student/${Username}`,{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				//console.log(res)
				commit('muttCoachSeeStudentNote', res.data)
			})
			.catch(error => {
				console.log(error)
			})
		},

		//UPDATE PERSONAL INFO ON PROFILE
		POST_UPDATE_PERSONAL_INFO({commit}, formData){
			axios.post(`/profile`,formData,
				{
					headers: {
						'Authorization': localStorage.token,
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}
			)
			.then(res => {
				commit('storeDataAdditional', res.data)
				commit('muttCckLoadDataPrsinfo', res)
			})
			.catch(err => {
				commit('muttCckLoadDataPrsinfo', err.response)
			})
		},

		POST_UPDATE_TIMEZONE({commit}, TimezoneData){
			axios({
				method: 'POST',
				url: '/timezones',
				data: TimezoneData,
				headers: {Authorization: localStorage.token}
			})
			.then(res =>{
				commit('storeDataAdditional', res.data)
				commit('muttCckLoadDtTmZone', res)
			})
			.catch(err => {
				commit('muttCckLoadDtTmZone', err.response)
			})
		},

		//ACTION FOR AVATAR
		POST_UPDATEAVATAR({commit}, formData){
			axios({
				method: 'POST',
				url: '/avatar',
				data : formData,
				headers: {
					'Authorization': localStorage.token,
					'Content-Type': 'multipart/form-data',
				},

			})
			.then(res => {
				commit('storeDataAdditional', res.data)
				commit('muttCckLoadAvatar', res)
			})
			.catch(err => {
				commit('muttCckLoadAvatar', err.response)
			})
		},

		//ACTION CHANGE PASSWORD
		POST_UPDATE_PASSWORD({commit}, ConvertFormpass){
			axios.patch(`/password`,ConvertFormpass,
				{
					headers: {
						'Authorization': localStorage.token,
						'Content-Type': 'application/json',
					}
				}
			)
			.then(res => {
				console.log(res)
				commit('storeChangePass', res.data)
			})
			.catch(err => {
				console.log(err.response)
				commit('storeChangePass', err.response.data)
			})
		},

		POST_FORGOT_PASSWORD({commit}, DataForgot){
			axios.post(`/password-reset`,DataForgot)
			.then(res => {
				console.log(res)
				commit('muttForgotPass', res)
			})
			.catch(err => {
				console.log(err.response)
				commit('muttForgotPass', err.response)
			})
		},

		// TOKEN ACTION
		GET_COIN({commit}){
			axios.get('/coins',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				//console.log(res)
				commit('dataToken', res.data.data)
			})
			.catch(error => {
				console.log(error)
			})
		},
		GET_PROFILE_TOKEN_HISTORY({commit}){
       axios.get('/coins/history',{
          headers: {
             Authorization: localStorage.token
          }
       })
       .then(res =>{
			commit('muttCheckCoinHistory', res)
			commit('storeDataDashTokenHistory', res.data)
			commit('commitTokenFilterDate', res.data)
       })
       .catch(err => {
			commit('muttCheckCoinHistory', err.response)
			commit('storeDataDashTokenHistory', err.response)
			commit('commitTokenFilterDate', err.response)
       })
    },
		POST_COIN ({commit}, tokenAmount) {
			axios({
        method: 'POST',
        url: '/coins',
        data: tokenAmount,
        headers: {Authorization: localStorage.getItem('token')}
       })
      .then(res => {
        console.log(res);
				commit('storeCoinRes', res)
				commit('commitSnackbarVal', true)
				commit('commitSnackbarMessage', res)
      })
			.catch(error => {
				console.log(error)
				commit('commitSnackbarVal', true)
				commit('commitSnackbarMessage', error.response)
			})
		},
		POST_TOKEN_FILTER_DATE ({commit, dispatch}, rangeDate) {
			axios({
        method: 'POST',
        url: '/coins/filter/',
        data: rangeDate,
        headers: {Authorization: localStorage.getItem('token')}
       })
       .then(res => {
         console.log(res);
         commit('commitTokenFilterDate', res.data)
       })
       .catch(function (error) {
         console.log(error);
       });
		},
		// TOKEN ACTION END

		// UPCOMING SESSSION
		GET_UPCOMING_SESSIONS({commit}){
			axios.get('/session/upcoming',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				console.log(res)
				commit('commitUpcomingSession', res.data)
			})
			.catch(err => {
				console.log(err.response)
				console.log(err)
			})
		},
		POST_UPCOMING_FILTER_DATE ({commit, dispatch}, rangeDate) {
			axios({
        method: 'POST',
        url: '/session/search_upcoming/',
        data: rangeDate,
        headers: {Authorization: localStorage.getItem('token')}
       })
       .then(res => {
         console.log(res);
         commit('commitUpcomingSession', res.data)
       })
       .catch(function (error) {
         console.log(error);
       });
		},
		POST_SESSION_DETAIL ({commit, dispatch}, coachData) {
			axios({
        method: 'POST',
        url: '/session/detail',
        data: coachData,
        headers: {Authorization: localStorage.getItem('token')}
       })
      .then(res => {
        console.log(res);
				commit('storeSessionDetail', res.data)
				commit('commitLoader', false)
      })
			.catch(error => {
				console.log(error)
				// commit('storeCoinRes', error.response)
			})
		},
		POST_SESSION_DETAIL_COACH ({commit, dispatch}, studentData) {
			axios({
        method: 'POST',
        url: '/session/detail',
				data: studentData,
        headers: {Authorization: localStorage.getItem('token')}
       })
      .then(res => {
        console.log(res);
				commit('storeSessionDetailCoach', res.data)
      })
			.catch(error => {
				console.log(error)
				// commit('storeCoinRes', error.response)
			})
		},
		POST_RESCHEDULE_DATE ({commit}, data) {
			axios({
        method: 'POST',
        url: '/reschedule',
				data: {
						date: data
				},
        headers: {Authorization: localStorage.getItem('token')}
       })
      .then(res => {
        console.log(res);
				commit('commitRescheduleCoachAvailable', res.data)
      })
			.catch(error => {
				console.log(error)
				// commit('storeCoinRes', error.response)
			})
		},
		POST_RESCHEDULE_COACH_AVAILABLE({commit}, data){
			axios({
				method: 'POST',
				url: '/reschedule',
				data: data,
				headers: {Authorization: localStorage.token}

			})
			.then(res => {
				console.log(res)
				commit('commitRescheduleCoachAvailable', res.data)
				commit('commitStartEndTime', res.data)
			})
			.catch(err => {
				console.log(err.response)
				// commit('storeTimeRescheduleAvailable', err.response.data)
			})
		},
		POST_CHECK_RESCHEDULE_COACH({commit}, CheckReschedule){
			axios({
				method: 'POST',
				url: '/reschedule/schedule',
				data : CheckReschedule,
				headers: {Authorization: localStorage.token}
			})
			.then(res => {
				console.log(res)
				commit('storeTimeRescheduleAvailable', res.data)

			})
			.catch(err => {
				console.log(err.response)
				commit('storeTimeRescheduleAvailable', err.response.data)
			})
		},
		POST_CONFIRM_RESCHEDULE ({commit}, rescheduleData) {
			axios({
				method: 'PATCH',
				url: '/reschedule/update',
				data : rescheduleData,
				headers: {Authorization: localStorage.token}
			})
			.then(res => {
				console.log(res)
				commit('stateRescheduleResponse', res.data)
			})
			.catch(err => {
				// console.log(err.response)
				// commit('stateRescheduleResponse', err.response.data)
			})
		},
		POST_SESSION_ID ({commit}, dataReq) {
			axios({
				method: 'POST',
				url: '/session/recording',
				data: dataReq,
				headers: {Authorization: localStorage.token}
			})
			.then(res => {
				console.log(res)
				commit('muttCckRecUrl', res)
				commit('commitRecUrl', res.data)
			})
			.catch(err => {
				console.log(err.response)
				commit('muttCckRecUrl', err.response)
			})
		},
		// UPCOMING SESSSION END

		// STUDY DASHBOARD
		GET_CALL1_CALL2 ({commit, state}, studentUsername) {
			axios.get(`study-dashboards/b2i${studentUsername.username}`,{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				//console.log(res)
				commit('muttCheckStudyDashb', res)
				commit('commitCall1Call2', res.data)
				state.loadingTrue = false
			})
			.catch(err => {
				console.log(err)
				commit('muttCheckStudyDashb', err.response)
				commit('commitCall1Call2Error', err.response)
			})
		},
		GET_STUDY_DASHBOARD ({commit, state}) {
			axios.get('study-dashboards/b2c',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				// console.log(res)
				commit('commitStudyDashboard', res.data)
			})
			.catch(error => {
				console.log(error)
			})
		},
		GET_STUDY_DASHBOARD_COACHING ({commit, state}) {
			axios.get('study-dashboards/b2c/study-records',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				// console.log(res)
				commit('commitStuDashCoaching', res.data)
			})
			.catch(error => {
				console.log(error)
			})
		},
		GET_WEEKLY_PROGRESS ({commit, state}) {
			axios.get('study-dashboards/b2c-weekly',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				console.log(res)
				commit('commitWeeklyProgress', res.data)
			})
			.catch(error => {
				console.log(error)
			})
		},
		POST_B2C_SUMMARY ({commit}){
			axios({
				method: 'POST',
				url: 'study-dashboards/b2c/summary',
				headers: {Authorization: localStorage.token}
			})
			.then(res => {
				console.log(res)
				commit('commitB2CSumary', res)
			})
			.catch(err => {
				console.log(err)
			})
		},
		// STUDY DASHBOARD END

		//ACTION FOR BOOK COACH PAGE
		POST_AVAILABLECOACH({commit}){
			axios({
				method: 'POST',
				url: '/book',
				headers: {Authorization: localStorage.token}
			})
			.then(res => {
				console.log(res)
				commit('storeDataAvailableCoach', res.data)
				commit('muttLoadAvCoach', res)
			})
			.catch(err => {
				console.log(err.response)
				commit('muttLoadAvCoach', err.response)
			})
		},

		POST_FILTERCOUNTRY({commit}, FilterCountry){
			axios({
				method: 'POST',
				url: '/book',
				data : {input: 'country', country: FilterCountry},
				headers: {Authorization: localStorage.token}
			})
			.then(res => {
				//console.log(res)
				commit('storeDataAvailableCoach', res.data)
				commit('muttloadFilter', res)
				commit('availableCoachDataSelect',{
					CoachIndex : 'undefined'
				})
			})
			.catch(err => {
				commit('muttloadFilter', err.response)
				commit('storeDataAvailableCoach', err.response.data)
			})
		},

		POST_FILTERLANGUAGE({commit}, FilterLanguage){
			axios({
				method: 'POST',
				url: '/book',
				data : {input: 'language', language: FilterLanguage},
				headers: {Authorization: localStorage.token}

			})
			.then(res => {
				console.log(res)
				commit('storeDataAvailableCoach', res.data)
				commit('muttloadFilter', res)
				commit('availableCoachDataSelect',{
					CoachIndex : 'undefined'
				})
			})
			.catch(err => {
				commit('muttloadFilter', err.response)
				commit('storeDataAvailableCoach', err.response.data)
			})
		},

		POST_FILTERNAME({commit}, FilterName){
			axios({
				method: 'POST',
				url: '/book',
				data : {input: 'name', name: FilterName},
				headers: {Authorization: localStorage.token}

			})
			.then(res => {
				console.log(res)
				commit('storeDataAvailableCoach', res.data)
				commit('muttloadFilter', res)
				commit('availableCoachDataSelect',{
					CoachIndex : 'undefined'
				})
			})
			.catch(err => {
				console.log(err.response)
				commit('storeDataAvailableCoach', err.response.data)
				commit('muttloadFilter', err.response)
			})
		},

		POST_FILTERDATE({commit}, FilterDate){
			axios({
				method: 'POST',
				url: '/book',
				data : {input: 'date', date: FilterDate},
				headers: {Authorization: localStorage.token}

			})
			.then(res => {
				console.log(res)
				commit('storeDataAvailableCoach', res.data)
				commit('muttloadFilter', res)
				commit('availableCoachDataSelect',{
					CoachIndex : 'undefined'
				})
			})
			.catch(err => {
				commit('muttloadFilter', err.response)
				commit('storeDataAvailableCoach', err.response.data)
			})
		},

		POST_FILTER_RECCURING({commit}, ReccuringData){
			axios({
				method: 'POST',
				url: '/book',
				data : ReccuringData,
				headers: {Authorization: localStorage.token}
			})
			.then(res => {
				console.log(res)
				commit('storeDataAvailableCoach', res.data)
				commit('muttloadFilter', res)
				commit('availableCoachDataSelect',{
					CoachIndex : 'undefined'
				})
			})
			.catch(err => {
				commit('muttloadFilter', err.response)
				commit('storeDataAvailableCoach', err.response.data)
			})
		},

		POST_CHECK_SCHEDULE_COACH_BY_RECURRING({commit}, CheckSchedule){
			axios({
				method: 'POST',
				url: '/book/schedule',
				data : CheckSchedule,
				headers: {Authorization: localStorage.token}
			})
			.then(res => {
				commit('storeCoachTimeAvailable', res.data)
				commit('muttLodingCkSchedule', res)
			})
			.catch(err => {
				commit('storeCoachTimeAvailable', err.response.data)
				commit('muttLodingCkSchedule', err.response)
			})
		},

		POST_CHECK_SCHEDULE_COACH({commit}, CheckSchedule){
			axios({
				method: 'POST',
				url: '/book/schedule',
				data : CheckSchedule,
				headers: {Authorization: localStorage.token}

			})
			.then(res => {
				commit('storeCoachTimeAvailable', res.data)
				commit('muttLodingCkSchedule', res)
			})
			.catch(err => {
				commit('storeCoachTimeAvailable', err.response.data)
				commit('muttLodingCkSchedule', err.response)
			})
		},

		POST_CHECK_DAYSOFF({commit}, dataCoachDaysOff){
			axios({
				method: 'POST',
				url: '/book/dayoff',
				data : dataCoachDaysOff,
				headers: {Authorization: localStorage.token}

			})
			.then(res => {
				commit('muttCoachDaysOff', res.data)

			})
			.catch(err => {
				console.log(err.response)
				commit('muttCoachDaysOff', err.response.data)
			})
		},

		POST_BOOK_SUMMARY({commit}, BookSummarydata){
			axios({
				method: 'POST',
				url: '/book/summary',
				data : BookSummarydata,
				headers: {Authorization: localStorage.token}
			})
			.then(res => {
				commit('storeCoachBookSummary', res.data)
				commit('muttloadSummary', res)
			})
			.catch(err => {
				commit('muttloadSummary', err.response)
			})
		},

		POST_BOOK_SUMMARY_RECURRING({commit}, BookSummarydata){
			axios({
				method: 'POST',
				url: '/book/summary',
				data : BookSummarydata,
				headers: {Authorization: localStorage.token}
			})
			.then(res => {
				commit('storeCoachBookSummary', res.data)
				commit('muttloadSummary', res)
			})
			.catch(err => {
				commit('muttloadSummary', err.response)
			})
		},

		POST_CONFIRM_SUMMARY({commit}, ConfirmBookSummary){
			axios({
				method: 'POST',
				url: '/book/create',
				data : ConfirmBookSummary,
				headers: {Authorization: localStorage.token}

			})
			.then(res => {
				console.log(res)
				commit('muttCckConfirmBookSummary',res)
				commit('storeConfirmSummary', res.data)

			})
			.catch(err => {
				console.log(err)
				commit('storeConfirmSummary', err.response)
				commit('muttCckConfirmBookSummary',err.response)
			})
		},

		GET_SELECTFILTER({commit}){
			axios.get('/book/list',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				commit('muttCheckFilterCoachLangCountry', res)
				commit('storeAvailableSelect', res.data)
			})
			.catch(err => {
				commit('muttCheckFilterCoachLangCountry', err.response)
				commit('storeAvailableSelect', err.response)
			})
		},

		//ACTION FOR DASHBOARD
		GET_DASH_UPCOMING_SESSIONS({commit}){
			axios.get('/session/upcoming',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				commit('muttCheckUpcomingSession', res)
				commit('storeDataUpcomingSession', res.data)
			})
			.catch(err => {
				commit('muttCheckUpcomingSession', err.response)
				commit('storeDataUpcomingSession', err.response)
			})
		},
		GET_PROFILE_TOKEN({commit}){
			axios.get('/coins',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				commit('muttCheckCoin', res)
				commit('storeGetToken', res.data)
			})
			.catch(err => {
				commit('storeGetToken', err.response)
				commit('muttCheckCoin', err.response)
			})
		},
		GET_DASH_UPCOMING_SESSIONS_FOR_SESSION_SUMMARY({commit}){
			axios.get('/session/upcoming',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				console.log(res)
				commit('muttLiveSessionSummary', res)
			})
			.catch(err => {
				commit('muttLiveSessionSummary', err.response)
			})
		},
		POST_START_SESSION_STUDENT ({commit}, dataStartSession) {
		  axios({
		    method: 'POST',
		    url: '/book/start',
		    data : dataStartSession,
		    headers: {Authorization: localStorage.token}

		  })
		  .then(res => {
		    console.log(res)
		    commit('commitStartSessionStd', res.data)
		    commit('muttStartLiveSession', res.data.user[0])

		    if (dataStartSession.type == 1 && res.status === 200){
		      router.push('/student/live')
		    } else if (dataStartSession.type == 0 && res.status === 200) {
		      router.push('/student/live/opentok')
		    }
		  })
		  .catch(error => {
		    console.log(error)
		  })
		},
		POST_SESSION_SUMMARY_STUDENT ({commit, dispatch}, SummaryData) {
			axios({
				method: 'POST',
				url: '/book/complete',
				data : SummaryData,
				headers: {Authorization: localStorage.token}

			})
			.then(res => {
				console.log(res)
				dispatch('GET_DASH_UPCOMING_SESSIONS')
				commit('MuttStudentSummary', res.data)

				if (res.status === 200){
					router.push('/student')
				}
			})
			.catch(error => {
				console.log(error)
			})
		},
		// POST_SESSION_SUMMARY_COACH ({commit}, SummaryData) {
		// 	axios({
		// 		method: 'POST',
		// 		url: '/book/complete',
		// 		data : SummaryData,
		// 		headers: {Authorization: localStorage.token}
		//
		// 	})
		// 	.then(res => {
		// 		console.log(res)
		// 		commit('MuttCoachSummary', res.data)
		//
		// 		if (res.status === 200){
		// 			router.push('/coach')
		// 		}
		// 	})
		// 	.catch(error => {
		// 		console.log(error)
		// 	})
		// },

		// GET TOKEN ACTION
		GET_TOKEN ({commit}) {
			axios.get('/coins', {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      })
      .then(res => {
        commit('commitToken', {
          UserToken: res.data.data
        })
        // console.log(UserToken);
      })
			.catch(error => {
				console.log(error)
			})
		},
		GET_COACH_SCHEDULES({commit}) {
			axios({
	      method: 'get',
	      url: '/schedules/',
	      headers: {Authorization: localStorage.getItem('token')}
	     })
	     .then(res => {
				commit('muttCheckCoachSchedules', res)
				commit('commitCoachSchedules', {
           		coachSchedules: res.data.data
         	})
	     })
	     .catch(err => {
			 console.log(err.response);
			 commit('muttCheckCoachSchedules', err.response)
	     });
		},

		// GET SESSION SIMULATOR API
		GET_SESSION_SIMULATOR ({commit}) {
		  axios({
		    method: 'GET',
		    url: '/session/simulator',
		    headers: {Authorization: localStorage.token}
		  })
		  .then(res => {
		    console.log(res)
		    commit('commitSessionSimulator', res.data)
		    if (res.data.simulator.type == "Opentok" && res.status === 200){
		      router.push('/student/opentok-simulator')
		    } else if (res.data.simulator.type == "Agora" && res.status === 200) {
		      router.push('/student/agora-simulator')
		    }
		  })
		  .catch(error => {
		    console.log(error)
		  })
		},

		// SERVER TIME
		GET_SERVER_TIME({commit, dispatch}){
			axios.get('/time',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				// console.log(res)
				commit('muttCheckServerTime', res)
				commit('commitServerTime', res.data)
			})
			.catch(err => {
				console.log(err)
				commit('muttCheckServerTime', err.response)
				commit('commitServerTime', err.response)
			})
		},

		// HELP PAGE
		GET_HELP ({commit}) {
			axios.get('/helps/type/student', {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      })
      .then(res => {
        commit('commitHelp', res.data)
      })
			.catch(error => {
				console.log(error)
			})
		},

		//HEADER NOTIFICATIONS
		GET_NOTIFICATIONS_ALL({commit}){
			axios.get('/notifications',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				commit('muttCheckHeaderAllNotif', res)
				commit('muttHeaderNotifALL', res.data)
			})
			.catch(err => {
				commit('muttCheckHeaderAllNotif', err)
				commit('muttHeaderNotifALL', err.response)
			})
		},

		GET_NOTIFICATIONS_LATEST({commit}){
			axios.get('/notifications/latest',{
				headers: {
					Authorization: localStorage.token
				}
			})
			.then(res =>{
				commit('muttCheckHeaderLastNotif', res)
				commit('muttHeaderNotifLatest', res.data)
			})
			.catch(err => {
				commit('muttCheckHeaderLastNotif', err)
				commit('muttHeaderNotifLatest', err.response)
			})
		},

		DELETE_ALL_NOTIFICATIONS({commit}){
			axios({
				method: 'DELETE',
				url: '/notifications/delete',
				headers: {
					'Authorization': localStorage.token
				},
			})
			.then(res =>{
				commit('muttCheckDeleteAllNotif', res)
				commit('muttHeaderNotifALL', res.data)
			})
			.catch(err => {
				commit('muttCheckDeleteAllNotif', err.response)
				commit('muttHeaderNotifALL', err.response)
			})
		},
	},

	getters: {
		IS_AUTHENTICATION(state){
			return state.ApiToken !== null
		},
		showDialog: state => {
			return state.showDialog
		},
		// GETTERS FOR PROFILE PAGE
		PROFILE_ADDITIONAL : state =>{
			return state.DataAdditional !== null
		},
		BOOK_VIEWCOACH : state =>{
			return state.AvailableCoach !== null
		},

		// GETTERS FOR BOOK A COACH
		IS_COACH : state => {
			return state.AvailableCoach
		},
		// IS_COACH_SCHEDULE_TIME : state => {
		// 	return state.AvailableTimeCoachSelect.coach_schedule !== 'no available time' || null
		// },
		IS_COACH_SCHEDULE_TIME : state => {
			return state.AvailableTimeCoachSelect
		},
		IS_BOOK_SUMMARY : state => {
			return state.AvailableBookSummary !== null
		},

		GETTERS_TOKENS (state) {
			return state.UserToken !== null
		},

		CHECK_CONFIRM_TOKENS (state) {
			return state.reqToken
		},

		COACH_SCHEDULES_UPDATE (state) {
			return state.statePostSchedule
		},

		//TO AUTHENTICATE STUDENT OR COACH
		IS_STUDENT_AUTH(state) {
			return state.ApiToken !== null
    },
    IS_COACH_AUTH(state) {
      const stateToken = state.ApiToken !== null
      const stateCoach = state.UserRoleId == 'coach'

      if (stateToken && stateCoach) {
        return true
      }
    },
		// UPCOMING SESSION GETTERS
		IS_RESCHEDULE_TIMEPICKER (state) {
			// return state.rescheduleTimeAvailable !== null
			// const coachAvailable = state.rescheduleTimeAvailable
			//
			// if (coachAvailable == null) {
      //   return false
      // } else if (coachAvailable.message == "Schedule not found") {
      //   return false
      // } else if (coachAvailable.status == "success") {
      //   return true
      // }
			return state.rescheduleTimeAvailable
		},
		// NOTIF GETTERS
		IS_NOTIF_COLOR (state) {
			return state.reqToken
    },
		IS_RESCHEDULE_COACH (state) {
			return state.rescheduleTimeAvailable
		},
		IS_NOTIF_SCHEDULE (state) {
      return state.statePostSchedule
    },
		// STUDY DASHBOARD STUFF
		fe (state) {
			if (state.stateCall1Call2 !== null) {
				return state.stateCall1Call2["call-1"].lessonCompletion.filter(x => x.name === 'First English  ')
			} else {
				return []
			}
    },
    nde (state) {
			if (state.stateCall1Call2 !== null) {
				return state.stateCall1Call2["call-1"].lessonCompletion.filter(x => x.name === 'New Dynamic English  ')
			} else {
				return []
			}
    },
    dbe (state) {
			if (state.stateCall1Call2 !== null) {
				return state.stateCall1Call2["call-1"].lessonCompletion.filter(x => x.name === 'Dynamic Business English  ')
			} else {
				return []
			}
    },
    tls (state) {
			if (state.stateCall1Call2 !== null) {
				return state.stateCall1Call2["call-1"].lessonCompletion.filter(x => x.name === 'The Lost Secret  ')
			} else {
				return []
			}
    },
    ebtn (state) {
			if (state.stateCall1Call2 !== null) {
				return state.stateCall1Call2["call-1"].lessonCompletion.filter(x => x.name === 'English By The Numbers  ')
			} else {
				return []
			}
    },
    fib (state) {
			if (state.stateCall1Call2 !== null) {
				return state.stateCall1Call2["call-1"].lessonCompletion.filter(x => x.name === 'Functioning in Business  ')
			} else {
				return []
			}
    },
    ali (state) {
			if (state.stateCall1Call2 !== null) {
				return state.stateCall1Call2["call-1"].lessonCompletion.filter(x => x.name === 'Advanced Listening  ')
			} else {
				return []
			}
    },
    dial (state) {
			if (state.stateCall1Call2 !== null) {
				return state.stateCall1Call2["call-1"].lessonCompletion.filter(x => x.name === 'Dialogue  ')
			} else {
				return []
			}
    },
		// STUDY DASHBOARD STUFF END

	 	//Check Loader Data Page Dashboard

		CCK_DASHBOARD (state) {
			const DataUpcoming = state.CheckUpcomingSession
			const HistoryCoin = state.CheckCoinHistory
			const CoinProfile = state.CheckCoin
			const FeedBack = []

			if (DataUpcoming !== null && HistoryCoin !== null && CoinProfile !== null){
				FeedBack.push(DataUpcoming.status)
				FeedBack.push(HistoryCoin.status)
				FeedBack.push(CoinProfile.status)
				return FeedBack
			}else{
				return 'IS NULL'
			}
		},

		//Check Loader Data Page Student Profile View

		CCK_STUDENT_PROFILE(state){
			const DataSessionHis = state.CheckShistory
         const DataCard = state.CckLoadDataProf
			//const DataStudy = state.CheckStudyDashb
			const FeedBack = []

			if (DataSessionHis !== null && DataCard !== null){
				FeedBack.push(DataSessionHis.status)
				FeedBack.push(DataCard.status)
				//FeedBack.push(DataStudy.status)
				return FeedBack
			}else{
				return 'IS NULL'
			}

		},

		//Check Loader Data Page Coach Profile View

		CCK_COACH_PROFILE(state){
			const DataCard = state.CckLoadDataOtherProf
			const FeedBack = []

			if (DataCard !== null ){
				FeedBack.push(DataCard.status)


				return FeedBack
			}else{
				return 'IS NULL'
			}

		},

		//Check Loader Data Header

		CCK_HEADER_LATEST(state){
			const DataProfile = state.CckLoadDataProf
			const DataHeaderLatest = state.CheckHeaderLastNotif
			const DataServerTime = state.CheckServerTime
			const FeedBack = []

			if (DataProfile !== null && DataHeaderLatest !== null && DataServerTime !== null){
				FeedBack.push(DataProfile.status)
				FeedBack.push(DataHeaderLatest.status)
				FeedBack.push(DataServerTime.status)
				return FeedBack
			}else{
				return 'IS NULL'
			}
		},

		//Check Loader Data Notification All

		CCK_NOTIF_ALL(state){
			const DataNotifAll = state.CheckHeaderAllNotif
			const FeedBack = []

			if(DataNotifAll !== null){
				FeedBack.push(DataNotifAll.status)
				return FeedBack
			}else{
				return 'IS NULL'
			}
		},

		//Check Loader Delete Notification ALL

		CCK_DELETE_NOTIL_ALL(state){
			const DataDeleteAll = state.CheckDeleteAllNotif
			const FeedBack = []

			if(DataDeleteAll !== null){
				FeedBack.push(DataDeleteAll.status)
				return FeedBack
			}else{
				return 'IS NULL'
			}
		},

		//Check Loader after Post Avatar

		CCK_UPDATE_AVATAR(state){
			const dataAvatar = state.CckLoadAvatar
			const FeedBack = []

			if(dataAvatar !== null){
				FeedBack.push(dataAvatar.status)
				return FeedBack
			}else{
				return 'IS NULL'
			}
		},

		//Check Load Book Coach

		CCK_BOOK_COACH(state){
			const dataCoachAV = state.LoadAvCoach
			const dataFilterLangCoun = state.CheckFilterCoachLangCountry
			const FeedBack = []

			if(dataCoachAV !== null && dataFilterLangCoun  !== null){
				FeedBack.push(dataCoachAV.status)
				FeedBack.push(dataFilterLangCoun.status)
				return FeedBack
			}else{
				return 'IS NULL'
			}
		},

		CCK_CONFIRM_BOOK_SUMMARY(state){
			const dataConfirmSummary = state.CckConfirmBookSummary
			const FeedBack = []

			if(dataConfirmSummary !== null){
				FeedBack.push(dataConfirmSummary)
				return FeedBack
			}else{
				return 'IS NULL'
			}
		},
		CCK_REC_URL_AGORA(state){
			const dataCckRecUrl = state.CckRecUrl
			const FeedBack = []

			if(dataCckRecUrl !== null){
				FeedBack.push(dataCckRecUrl.status)
				return FeedBack
			}else{
				return 'IS NULL'
			}

		}

	},
	plugins: [createPersistedState()],
})



// WEBPACK FOOTER //
// ./src/store/store.js